import React, {useMemo, useCallback} from 'react';
import {FlatList} from 'react-native';
import moment from 'moment';

import sy from '~/styles';
import CalendarMonth from './Month';
import PropTypes from 'prop-types';

const CELL_WIDTH = 45;

// Shared, stable `months` values. Callers must not pass an inline array
// literal: a fresh identity on every render invalidates the layout memo below
// and forces every month to be re-measured.
export const MONTHS_3_PAST_6_FUTURE = [-3, -2, -1, 0, 1, 2, 3, 4, 5, 6];
export const MONTHS_1_PAST_6_FUTURE = [-1, 0, 1, 2, 3, 4, 5, 6];
export const MONTHS_6_FUTURE = [0, 1, 2, 3, 4, 5, 6];

const Calendar = ({style, months, initialDate, date, minDate, onPress}) => {
  // Precompute each month's height together with its cumulative offset. Summing
  // the preceding months inside getItemLayout re-walks the list on every call,
  // making layout O(n^2) — especially costly here because initialScrollIndex
  // forces every month up to the initial one to be laid out before first paint.
  const layouts = useMemo(() => {
    const result = [];
    let offset = 0;

    for (let index of months) {
      const month = moment(initialDate).add(index, 'month');
      const start = moment(month).startOf('month');
      const end = start.clone().endOf('month');
      const weeks = end.diff(start.clone().startOf('week'), 'week');

      const month_label_height = CELL_WIDTH;
      const length = month_label_height + (weeks + 1) * CELL_WIDTH;

      result.push({length, offset, index: result.length});
      offset += length;
    }

    return result;
  }, [initialDate, months]);

  const getItemLayout = useCallback((data, index) => layouts[index], [layouts]);

  if (layouts.length > 0) {
    return (
      <FlatList
        style={[sy['pl-4'], {maxHeight: 400}, style]}
        data={months}
        renderItem={({item}) => (
          <CalendarMonth
            cellWidth={CELL_WIDTH}
            month={moment(initialDate).add(item, 'month')}
            date={date}
            minDate={minDate}
            onPress={onPress}
          />
        )}
        keyExtractor={(item) => item}
        initialScrollIndex={months.indexOf(0)}
        getItemLayout={getItemLayout}
      />
    );
  }

  return null;
};
Calendar.propTypes = {
  style: PropTypes.any,
  months: PropTypes.any,
  initialDate: PropTypes.any,
  date: PropTypes.any,
  minDate: PropTypes.any,
  onPress: PropTypes.any,
};


export default React.memo(Calendar);
